import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to the top whenever the route changes. Uses an instant jump
// because html has `scroll-behavior: smooth`, which would otherwise animate
// and can be interrupted while the new page is still rendering.
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
